export default __webpack_public_path__ + "static/pem-adding-datatag-9b4eb46de23dda2386bb52652ea7241d.mp4";